// @flow
import React, { Component } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import Scrollable from '../../components/shared/Scrollable';
import { colors } from '../../shared/styles';

const ListContent = styled.div`
    .list-content {
        height: calc(100vh - 152px);
        padding-bottom: 70px;
    }

    .simplebar-content {
        overflow-x: hidden;
    }
`;

const StyledTable = styled.table`
    max-width: 100%;
    width: 100%;
    text-align: left;

    &,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        vertical-align: baseline;
        border-collapse: collapse;
        border-spacing: 0;
        text-align: left;
    }

    & {
        width: 100%;
    }

    thead {
        background: #edf1f2;
        overflow: hidden;
        border-bottom: 1px solid #d9d9db;
    }

    th {
        box-sizing: border-box;
        width: calc((100% - 100px) / 3);
        font-weight: normal;
        text-align: left;
        padding: 15px 20px;

        &:last-of-type {
            width: 95px;
        }
    }

    tbody {
        background: #f3f3f5;

        &:nth-of-type(odd) {
            background: ${colors.white};
        }

        tr {
            font-weight: lighter;

            &:first-of-type {
                td {
                    padding: 10px 20px 5px;
                }
            }

            &:last-of-type {
                td {
                    padding: 5px 20px 10px;
                    font-size: 14px;
                }
            }
        }
    }

    td {
        vertical-align: middle;

        &:not(:last-of-type) {
            width: calc((100% - 115px) / 6);
        }

        &.end-date {
            &--active {
                color: green;
            }

            &--inactive {
                color: red;
            }
        }
    }

    .btn {
        display: block;
        padding: 7px 15px;
        color: #fff;
        text-decoration: none;
        background: #e76424;
        border-radius: 4px;
        border: none !important;
        font-weight: lighter !important;
        font-size: 14px !important;
        cursor: pointer;
    }

    .actions {
        text-align: right;

        .action-btn:last-child {
            margin-right: 0;
        }
    }

    .actions a,
    .actions button {
        position: relative;
        display: inline-block;
        margin: 8px 8px 8px 0;
        padding: 5px 8px;
        color: #fff;
        text-decoration: none;
        background: #e76424;
        border: none !important;
        font-weight: lighter !important;
        font-size: 14px !important;
        line-height: 16px !important;
        cursor: pointer;
        border-radius: 4px;
        border: none;
    }

    .action-btn .tooltip {
        position: absolute;
        font-size: 12px;
        width: 140px;
        color: #ffffff;
        background: #48555b;
        height: 30px;
        line-height: 30px;
        text-align: center;
        visibility: hidden;
        border-radius: 4px;
    }

    .action-btn .tooltip-wide {
        width: 200px;
    }

    .action-btn .tooltip:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 100%;
        margin-top: -8px;
        width: 0;
        height: 0;
        border-left: 8px solid #48555b;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
    }

    .action-btn:hover .tooltip {
        visibility: visible;
        right: 100%;
        top: 50%;
        margin-top: -15px;
        margin-right: 13px;
        z-index: 999;
    }
`;

const TableRow = ({ contactReassigns, contactReAssignId, onDelete }) => {
    let activeContactReassign = '';

    if (
        moment(
            contactReassigns[contactReAssignId].contactReAssignStartAt
        ).isSameOrBefore() &&
        moment(
            contactReassigns[contactReAssignId].contactReAssignRollbackedAt
        ).isAfter()
    ) {
        activeContactReassign = 'end-date--active';
    } else if (
        moment(
            contactReassigns[contactReAssignId].contactReAssignRollbackedAt
        ).isBefore()
    ) {
        activeContactReassign = 'end-date--inactive';
    }

    return (
        <tbody>
            <tr>
                <td colSpan={2}>
                    {`${contactReassigns[contactReAssignId].contactAssignFrom
                        .contactForenames} ${contactReassigns[contactReAssignId]
                        .contactAssignFrom.contactSurname}`}
                </td>
                <td colSpan={2}>
                    {`${contactReassigns[contactReAssignId].contactAssignTo
                        .contactForenames} ${contactReassigns[contactReAssignId]
                        .contactAssignTo.contactSurname}`}
                </td>
                <td rowSpan={2}>
                    {moment(
                        contactReassigns[contactReAssignId]
                            .contactReAssignStartAt
                    ).format('DD/MM/YYYY')}
                </td>
                <td rowSpan={2} className={`end-date ${activeContactReassign}`}>
                    {moment(
                        contactReassigns[contactReAssignId]
                            .contactReAssignRollbackedAt
                    ).format('DD/MM/YYYY')}
                </td>
                <td className="actions" rowSpan={2}>
                    <button
                        className="action-btn"
                        onClick={() => {
                            onDelete(contactReassigns[contactReAssignId]);
                        }}
                    >
                        <i className="fa fa-trash" />
                        <span className="tooltip">Delete</span>
                    </button>
                </td>
            </tr>
            <tr>
                <td>
                    {
                        contactReassigns[contactReAssignId].contactAssignFrom
                            .contactEmail
                    }
                </td>
                <td>
                    {
                        contactReassigns[contactReAssignId].contactAssignFrom
                            .contactTelephone
                    }
                </td>
                <td>
                    {
                        contactReassigns[contactReAssignId].contactAssignTo
                            .contactEmail
                    }
                </td>
                <td>
                    {
                        contactReassigns[contactReAssignId].contactAssignTo
                            .contactTelephone
                    }
                </td>
            </tr>
        </tbody>
    );
};

class List extends Component {
    contactReassigns: Object;
    onDelete: Function;
    contactReAssignId: String;

    render() {
        const { contactReassigns, onDelete } = this.props;

        return (
            <ListContent>
                <Scrollable additionalClassName="list-content">
                    <StyledTable>
                        <thead>
                            <tr>
                                <th colSpan={2}>From</th>
                                <th colSpan={2}>To</th>
                                <th>Start</th>
                                <th>End</th>
                                <th />
                            </tr>
                        </thead>
                        {contactReassigns
                            ? Object.keys(
                                  contactReassigns
                              ).map(contactReAssignId => {
                                  return (
                                      <TableRow
                                          key={contactReAssignId}
                                          contactReassigns={contactReassigns}
                                          contactReAssignId={contactReAssignId}
                                          onDelete={onDelete}
                                      />
                                  );
                              })
                            : null}
                    </StyledTable>
                </Scrollable>
            </ListContent>
        );
    }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/ContactReassigns/List.js